
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router,ActivatedRoute } from "@angular/router";
import { ModalEmailService } from "../../../../common/modal-email/modal-email.service";

@Component({
  selector: 'service-user',
  templateUrl: '../../templates/partials/user-service.html'
})
export class UserServiceComponent{

  @Input() userData;
  @Output() modalEmailEmitter = new EventEmitter();
  public hideLink = false;

  constructor(private router: Router, private modalEmailService: ModalEmailService, private route: ActivatedRoute){
    this.route.params.subscribe(params => {
      if(params["id"]){
        this.hideLink = true;
      }
    });
  }

  public showModalEmail(email: string){

    this.modalEmailService.openModalEmail(email);
  }

  
  ngOnChanges(changes: any){}

  public goToUser(){
    var id = this.userData["userId"] || this.userData["id_user"] || this.userData["id_client"];
    this.router.navigate(["users",id])
  }

}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/dummy/user-service.component.ts